import React, { lazy } from 'react';
import { MapPinIcon, ClockIcon, PhoneIcon, ExternalLinkIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Locations() {
  const locationData = [{
    name: 'Annapolis Pharmacy',
    address: '2002 Jennifer Rd, Annapolis, MD 21401',
    phone: '(410) 555-0123',
    googleMapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=2002+Jennifer+Rd+Annapolis+MD+21401',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3091.5645367355!2d-76.5444!3d38.9897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7f6562688997b%3A0x67397730e6686a9d!2s2002%20Jennifer%20Rd%2C%20Annapolis%2C%20MD%2021401!5e0!3m2!1sen!2sus!4v1715980000000!5m2!1sen!2sus',
    hours: [{
      days: 'Mon - Fri',
      time: '9:00 AM - 7:00 PM'
    }, {
      days: 'Sat',
      time: '10:00 AM - 4:00 PM'
    }, {
      days: 'Sun',
      time: 'Closed'
    }]
  }, {
    name: 'Washington D.C. Pharmacy',
    address: '1234 Pennsylvania Ave NW, Washington, D.C. 20004',
    phone: '(202) 555-0199',
    googleMapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=1234+Pennsylvania+Ave+NW+Washington+DC+20004',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105.150381926!2d-77.029!3d38.895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b7bcdecbb1df%3A0x715969d86d0b7105!2s1234%20Pennsylvania%20Ave%20NW%2C%20Washington%2C%20DC%2020004!5e0!3m2!1sen!2sus!4v1715980000000!5m2!1sen!2sus',
    hours: [{
      days: 'Mon - Fri',
      time: '8:30 AM - 6:30 PM'
    }, {
      days: 'Sat',
      time: '10:00 AM - 2:00 PM'
    }, {
      days: 'Sun',
      time: 'Closed'
    }]
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white pb-12 sm:pb-24" data-id="element-490">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-20 mb-8 sm:mb-16" data-id="element-491">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4 sm:mb-6 uppercase tracking-tighter" data-id="element-492">
          Our Locations
        </h1>
        <p className="text-base sm:text-lg text-slate-600 max-w-3xl" data-id="element-493">
          Visit us at either of our convenient locations. We provide
          professional pharmaceutical care and clinical services to our local
          communities.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-494">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12" data-id="element-495">
          {locationData.map((loc, idx) => <div key={idx} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-496">
              <div className="aspect-video w-full" data-id="element-497">
                <iframe src={loc.mapUrl} width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={loc.name} className="grayscale hover:grayscale-0 transition-all duration-500" data-id="element-498"></iframe>
              </div>
              <div className="p-6 sm:p-8" data-id="element-499">
                <h2 className="text-xl sm:text-2xl font-black text-slate-900 mb-6 uppercase tracking-tight" data-id="element-500">
                  {loc.name}
                </h2>

                <div className="space-y-6 mb-8" data-id="element-501">
                  <div className="flex items-start gap-4" data-id="element-502">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-503">
                      <MapPinIcon className="w-5 h-5" data-id="element-504" />
                    </div>
                    <div data-id="element-505">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-506">
                        Address
                      </p>
                      <p className="text-slate-600 text-sm leading-relaxed" data-id="element-507">
                        {loc.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-508">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-509">
                      <PhoneIcon className="w-5 h-5" data-id="element-510" />
                    </div>
                    <div data-id="element-511">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-512">
                        Phone
                      </p>
                      <p className="text-slate-600 text-sm" data-id="element-513">{loc.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-514">
                    <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue flex-shrink-0" data-id="element-515">
                      <ClockIcon className="w-5 h-5" data-id="element-516" />
                    </div>
                    <div className="flex-grow" data-id="element-517">
                      <p className="text-sm font-bold text-slate-900 uppercase tracking-wide mb-1" data-id="element-518">
                        Business Hours
                      </p>
                      <div className="space-y-1" data-id="element-519">
                        {loc.hours.map((h, i) => <div key={i} className="flex justify-between text-sm text-slate-600" data-id="element-520">
                            <span data-id="element-521">{h.days}</span>
                            <span className="font-medium" data-id="element-522">{h.time}</span>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-523">
                  <a href={loc.googleMapsUrl} target="_blank" rel="noopener noreferrer" className="flex-grow bg-clinical-blue text-white font-bold py-3 sm:py-4 rounded-xl hover:bg-blue-700 transition-colors uppercase tracking-wider text-xs flex items-center justify-center gap-2" data-id="element-524">
                    Get Directions <ExternalLinkIcon className="w-4 h-4" data-id="element-525" />
                  </a>
                  <button className="px-6 border-2 border-clinical-blue text-clinical-blue font-bold py-3 sm:py-4 rounded-xl hover:bg-clinical-blue hover:text-white transition-all uppercase tracking-wider text-xs" data-id="element-526">
                    Call Store
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </motion.div>;
}